import request from '@/utils/request'

export const getUserInfo = async(data: any): Promise<any> => {
  return request({
    url: '/users/self',
    method: 'get',
    data
  })
}

export const login = async(data: any): Promise<any> => {
  return request({
    url: '/auth/console/signin',
    method: 'post',
    data
  })
}

export const logout = async(): Promise<any> => {
  return request({
    url: '/auth/console/signout',
    method: 'post'
  })
}
